import React, { createRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Paper from "@material-ui/core/Paper";
import { Row, Col } from "react-flexbox-grid";
import FiltersBar from "../filters";
import InitialLoader from "../initialLoader";
import Progress from "../progress";
import SimpleTabs from "../tabs";
import { clearState as csData } from "../data/ducks";

class Index extends React.Component {
  barChartRef = createRef();

  componentWillUnmount() {
    this.props.clearState();
  }

  render() {

    return (
      <Row style={{marginTop : 15, marginRight : 5, marginLeft : 5, marginBottom : 20}}>
        <Col lg={7} md={7} xs={12} elevation={1}>
          <Paper style={{ padding: 10 }}>
            <FiltersBar 
              indicator = {
                this.props.location.params ? 
                this.props.location.params.indicatorType : 
                JSON.parse(localStorage.getItem("indicatorType"))}
            />
          </Paper>
          <InitialLoader />
        </Col>
        <Col md={5} xs={12}>
          <div ref={this.barChartRef} style={{ width: "100%", height: "100%" }}>
            <Progress />
            <SimpleTabs barChartRef={this.barChartRef} />
          </div>
        </Col>
      </Row>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      clearState: csData
    },
    dispatch
  );

export default connect(
  null,
  mapDispatchToProps
)(Index);



// WEBPACK FOOTER //
// ./src/components/main-page/index.js